var _style, _path, _path2, _circle, _circle2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "receipt_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".receipt_svg__st2{fill:#f9af17}.receipt_svg__st4,.receipt_svg__st5{fill:none;stroke:#35a4dd;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.receipt_svg__st5{stroke:#f9af17}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 98.8v839.8L327 866.1 510.6 952 698 866.1l155.5 72.5V98.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.3 257.6h295.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317.7,
    cy: 491.8,
    r: 32.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.7,
    cy: 647.9,
    r: 32.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M704.9 491.8h-264M704.9 647.9h-264"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M977.4 69.8H46"
  })));
}

export default SvgReceipt;